import { Header, RichTextDisplay } from "@datagame/ui";
import { t } from "i18next";
import classNames from "classnames/bind";

import { Destination } from "../RankifierCard/Destination";
import { ProgressBar } from "../../shared/ProgressBar";
import { useRankifierState } from "../../../hooks/useRankifierState";
import { useGlobalConfiguration } from "../../../hooks/useGlobalConfiugration";

import styles from "./Playground.module.scss";

const cx = classNames.bind(styles);

export const Playground = () => {
  const [
    {
      status: { isPickingFavorite, round },
      game: {
        configuration: {
          numberOfHands,
          leastQuestion,
          mostQuestion,
          gameVisuals: { backgroundPositiveColor, backgroundNegativeColor, backgroundImage, themeColor },
        },
      },
    },
  ] = useRankifierState();
  const { hideDatagameBranding } = useGlobalConfiguration();

  const backgroundColor = isPickingFavorite ? backgroundPositiveColor : backgroundNegativeColor;
  const backgroundColorStyles = !backgroundImage ? { backgroundColor } : undefined;

  const backgroundImageStyle = backgroundImage ? { backgroundImage: `url(${backgroundImage.url})` } : undefined;
  return (
    <div className={cx("rankifierPlayground", isPickingFavorite ? "like" : "dislike")} style={backgroundImageStyle}>
      <div className={styles.backgroundCircle} style={backgroundColorStyles} />
      <div className={styles.backgroundCircle} style={backgroundColorStyles} />
      <ProgressBar color={themeColor} currentStep={round - 1} steps={numberOfHands} className={styles.progressBar} />
      {!hideDatagameBranding && (
        <Header className={styles.playgroundStatus} variant="h6">
          {t(`rankifier.${isPickingFavorite ? "most" : "least"}`)}
        </Header>
      )}
      <Header
        variant="h5"
        className={cx("rankifierPlaygroundHeader", { hideDatagameBranding })}
      >
        <RichTextDisplay value={isPickingFavorite ? mostQuestion : leastQuestion} />
      </Header>

      <Destination kind="hand" />
    </div>
  );
};
